// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import JsPDF from '../../../node_modules/jsPDF-master'
export default {
  install(Vue, options) {
    Vue.prototype.getPdf = function(id) {
      var title = '货物运输合同'
      console.log(id)
      var id = id == undefined ? '#pdfDom' : id
      // var id = '#pdfDom'

      // document.querySelector('#pdfDom').style.display = "block"
      var c = document.createElement('canvas')
      var opts = {
        scale: 2,
        canvas: c,
        logging: true,
        width: document.querySelector(id).clientWidth,
        height: document.querySelector(id).clientHeight
      }
      c.width = document.querySelector(id).clientWidth * 2
      c.height = document.querySelector(id).clientHeight * 2
      c.getContext('2d').scale(1, 1)
      html2Canvas(document.querySelector(id), opts).then(function(canvas) {
        let contentWidth = canvas.width
        let contentHeight = canvas.height
        let pageHeight = (contentWidth / 592.28) * 841.89
        let leftHeight = contentHeight
        let position = 0
        let imgWidth = 595.28
        let imgHeight = (592.28 / contentWidth) * contentHeight
        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        let PDF = new JsPDF('', 'pt', 'a4')
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            if (leftHeight > 0) {
              PDF.addPage()
            }
          }
        }
        PDF.save(title + '.pdf')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/topdf.js